import ReleaseForm from './ReleaseForm';
import { can } from '../../../permissions';

import ResponsiveTable from '../../ReusableComponents/ResponsiveTable';
import ConfirmButton from './ConfirmButton';
import PortalButton from './PortalButton';
import React, { useState } from 'react';
import moment from 'moment';
import { MdEdit, MdDelete, MdAdd } from 'react-icons/md';
import { usePortalQuery, usePortalMutation, usePortal } from '../hooks';
import { ErrorNotice, Loading, Status, Empty } from './Feedback';
const types = {
  booklet: 'Caderno',
  answers: 'Respostas do candidato',
  answer_key: 'Gabarito',
  scores: 'Notas e acertos',
  preliminary: 'Resultado preliminar',
  final: 'Resultado definitivo',
  essay: 'Redações e correções',
};
export default function ReleaseManager({ selection }) {
  const { user } = usePortal();
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const [adding, setAdding] = useState(false);
  const path = `selecoes/${selection.id}/liberacoes`,
    query = usePortalQuery(path),
    remove = usePortalMutation((d) => `${path}/${d.id}`, 'DELETE'),
    [editing, setEditing] = useState(null);
  return (
    <section className="card module-card module-content">
      <div className="card-body">
        <div className="portal-admin-row">
          <div className="module-content-heading">
            <h2>Liberação de resultados</h2>
            <p>Defina quando os candidatos poderão consultar cada conteúdo.</p>
          </div>
          <PortalButton
            className="btn btn-success hidethis"
            disabled={!allowed}
            onClick={() => {
              setEditing(null);
              setAdding(true);
            }}
          >
            <MdAdd /> Nova liberação
          </PortalButton>
        </div>
        <p>
          As permissões e datas oficiais da OnTest continuam sendo respeitadas. A configuração de um
          cargo prevalece sobre a configuração geral.
        </p>
        <ErrorNotice error={query.error || remove.error} />
        {query.isLoading ? (
          <Loading />
        ) : query.data?.data?.length === 0 ? (
          <Empty>Nenhum registro encontrado.</Empty>
        ) : (
          <ResponsiveTable className="table table-striped">
            <thead>
              <tr>
                <th>Conteúdo</th>
                <th>Cargo</th>
                <th>Período</th>
                <th>Situação</th>
                <th className="hidethis">Ações</th>
              </tr>
            </thead>
            <tbody>
              {query.data?.data?.map((p) => (
                <tr key={p.id}>
                  <td>{types[p.type]}</td>
                  <td>
                    {selection.positions.find((c) => c.id === p.position_id)?.title || 'Todos'}
                  </td>
                  <td>
                    {p.starts_at ? moment(p.starts_at).format('DD/MM/YYYY HH:mm') : 'Sem início'}
                    <br />
                    {p.ends_at ? moment(p.ends_at).format('DD/MM/YYYY HH:mm') : 'Sem fim'}
                  </td>
                  <td>
                    <Status value={p.enabled ? 'approved' : 'cancelled'} />
                  </td>
                  <td className="hidethis">
                    <div className="portal-admin-actions actions-group">
                      <PortalButton
                        className="btn btn-sm btn-primary"
                        title="Editar liberação"
                        onClick={() => {
                          setAdding(false);
                          setEditing(p);
                        }}
                        disabled={!allowed}
                        type="button"
                      >
                        <MdEdit />
                      </PortalButton>
                      <ConfirmButton
                        className="btn btn-sm btn-danger"
                        title="Excluir liberação"
                        disabled={!remove.allowed || remove.isLoading}
                        type="button"
                        message={'Excluir esta liberação?'}
                        onConfirm={() =>
                          remove.mutate({
                            id: p.id,
                          })
                        }
                      >
                        <MdDelete />
                      </ConfirmButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        )}
        {(adding || editing) && (
          <ReleaseForm
            selection={selection}
            item={editing}
            onDone={() => {
              setAdding(false);
              setEditing(null);
            }}
          />
        )}
      </div>
    </section>
  );
}
